<template>
  <button
      :class="small? 'py-0.5 px-4' : ''"
      :disabled="disabled"
      class="flex flex-none font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-1.5 px-4 text-primary-700 text-base bg-primary-400 rounded hover:shadow-button hover:bg-primary-100 focus:bg-[#AFA6E8] focus:shadow-none active:bg-[#AFA6E8] active:shadow-none disabled:bg-grays-400 disabled:shadow-none disabled:text-grays-600"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "button-secondary",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>

</style>